import * as React from "react";

import { JobType } from "@relode/core";
import { OrderReceipt } from "../../../../shared/components";
import { useAddJobContext } from "../../_infra";
import { useClasses } from "./steps.styling";

export const Step3 = () => {
    const classes = useClasses({});
    const {
        jobSteps: {
            stepThree: {
                jobId,
                jobLocationName,
                planName,
                postingFeeInUSDollars,
                successFeePercentage,
                successFeeInUSDollars,
                successFeeSavingsInUSDollars,
                employmentGuarantee,
                jobPriorityType,
                quantity,
                defaultPostingFeeInUSDollars,
                marketResearchFeatureType,
                defaultJobPriorityASuccessFeePercentage,
                defaultJobPriorityBSuccessFeePercentage,
                defaultJobPriorityCSuccessFeePercentage,
                defaultJobPriorityDSuccessFeePercentage,
                estimatedDefaultJobPriorityASuccessFeeInUSDollars,
                estimatedDefaultJobPriorityBSuccessFeeInUSDollars,
                estimatedDefaultJobPriorityCSuccessFeeInUSDollars,
                estimatedDefaultJobPriorityDSuccessFeeInUSDollars,
                estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars,
                estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars,
                estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars,
                estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars,
                jobManagerFullName,
                jobManagerUserId,
                jobManagerRoleType,
                billRateInUSDollars,
                estimatedContractBillTotalInUSDollars,
                estimatedContractBillTotalSavingsInUSDollars,
                hasSignedAgreement,
                jobSalaryInUSDollars,
                contractStartDate,
                contractEndDate,
                hoursPerWeek,
            },
            stepTwo: { jobName, jobTypeId },
        },
    } = useAddJobContext();

    return (
        <div className={classes.step3Form}>
            <OrderReceipt
                planName={planName}
                employmentGuarantee={employmentGuarantee}
                totalPositionQuantity={quantity}
                jobName={jobName}
                jobLocation={jobLocationName}
                jobId={jobId}
                jobManagerUserId={jobManagerUserId}
                jobManagerFullName={jobManagerFullName}
                jobManagerRoleName={jobManagerRoleType?.roleName}
                postingFeeInUSDollars={postingFeeInUSDollars}
                successFeePercentage={successFeePercentage}
                successFeeInUSDollars={successFeeInUSDollars}
                successFeeSavingsInUSDollars={successFeeSavingsInUSDollars}
                defaultPostingFeeInUSDollars={defaultPostingFeeInUSDollars}
                marketResearchFeatureType={marketResearchFeatureType}
                defaultJobPriorityASuccessFeePercentage={
                    defaultJobPriorityASuccessFeePercentage
                }
                defaultJobPriorityBSuccessFeePercentage={
                    defaultJobPriorityBSuccessFeePercentage
                }
                defaultJobPriorityCSuccessFeePercentage={
                    defaultJobPriorityCSuccessFeePercentage
                }
                defaultJobPriorityDSuccessFeePercentage={
                    defaultJobPriorityDSuccessFeePercentage
                }
                estimatedDefaultJobPriorityASuccessFeeInUSDollars={
                    estimatedDefaultJobPriorityASuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityBSuccessFeeInUSDollars={
                    estimatedDefaultJobPriorityBSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityCSuccessFeeInUSDollars={
                    estimatedDefaultJobPriorityCSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityDSuccessFeeInUSDollars={
                    estimatedDefaultJobPriorityDSuccessFeeInUSDollars
                }
                estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars={
                    estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars={
                    estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars={
                    estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars
                }
                estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars={
                    estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars
                }
                isFullTimeOrPartTime={JobType.isFullTimeOrPartTime(jobTypeId)}
                jobPriorityType={jobPriorityType}
                billRateInUSDollars={billRateInUSDollars}
                estimatedContractBillTotalInUSDollars={
                    estimatedContractBillTotalInUSDollars
                }
                estimatedContractBillTotalSavingsInUSDollars={
                    estimatedContractBillTotalSavingsInUSDollars
                }
                hasSignedAgreement={hasSignedAgreement}
                hoursPerWeek={hoursPerWeek}
                payRateInUSDollars={jobSalaryInUSDollars}
                contractStartDate={contractStartDate}
                contractEndDate={contractEndDate}
            />
        </div>
    );
};
